<!-- Topbar Start -->
<div class="navbar-custom">
  <div class="container-fluid">
    <ul class="list-unstyled topnav-menu float-right mb-0">

      <!--      <li class="dropdown notification-list">-->
      <!--        &lt;!&ndash; Mobile menu toggle&ndash;&gt;-->
      <!--        <a class="navbar-toggle nav-link">-->
      <!--          <div class="lines">-->
      <!--            <span></span>-->
      <!--            <span></span>-->
      <!--            <span></span>-->
      <!--          </div>-->
      <!--        </a>-->
      <!--        &lt;!&ndash; End mobile menu toggle&ndash;&gt;-->
      <!--      </li>-->
      <!--      <li class="dropdown notification-list">-->
      <!--        <a class="nav-link dropdown-toggle  waves-effect waves-light" data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false" (click)="expandNotifications()">-->
      <!--          <i class="fe-bell noti-icon"></i>-->
      <!--          <span class="badge badge-danger rounded-circle noti-icon-badge">9</span>-->
      <!--        </a>-->
      <!--        <div class="dropdown-menu dropdown-menu-right dropdown-lg">-->
      <!--          &lt;!&ndash; item&ndash;&gt;-->
      <!--          <div class="dropdown-item noti-title">-->
      <!--            <h5 class="m-0">-->
      <!--                                    <span class="float-right">-->
      <!--                                        <a href="" class="text-dark">-->
      <!--                                            <small>Clear All</small>-->
      <!--                                        </a>-->
      <!--                                    </span>Notification-->
      <!--            </h5>-->
      <!--          </div>-->
      <!--          <div #notifications slimScroll class="kajshdf noti-scroll">-->
      <!--            &lt;!&ndash; item&ndash;&gt;-->
      <!--            <a href="javascript:void(0);" class="dropdown-item notify-item">-->
      <!--              <div class="notify-icon bg-success"><i class="mdi mdi-comment-account-outline"></i></div>-->
      <!--              <p class="notify-details">Caleb Flakelar commented on Admin<small class="text-muted">1 min ago</small></p>-->
      <!--            </a>-->
      <!--            &lt;!&ndash; item&ndash;&gt;-->
      <!--            <a href="javascript:void(0);" class="dropdown-item notify-item">-->
      <!--              <div class="notify-icon bg-info"><i class="mdi mdi-account-plus"></i></div>-->
      <!--              <p class="notify-details">New user registered.<small class="text-muted">5 hours ago</small></p>-->
      <!--            </a>-->
      <!--            &lt;!&ndash; item&ndash;&gt;-->
      <!--            <a href="javascript:void(0);" class="dropdown-item notify-item">-->
      <!--              <div class="notify-icon bg-danger"><i class="mdi mdi-heart"></i></div>-->
      <!--              <p class="notify-details">Carlos Crouch liked <b>Admin</b><small class="text-muted">3 days ago</small></p>-->
      <!--            </a>-->
      <!--            &lt;!&ndash; item&ndash;&gt;-->
      <!--            <a href="javascript:void(0);" class="dropdown-item notify-item">-->
      <!--              <div class="notify-icon bg-warning"><i class="mdi mdi-comment-account-outline"></i></div>-->
      <!--              <p class="notify-details">Caleb Flakelar commented on Admin<small class="text-muted">4 days ago</small></p>-->
      <!--            </a>-->
      <!--            &lt;!&ndash; item&ndash;&gt;-->
      <!--            <a href="javascript:void(0);" class="dropdown-item notify-item">-->
      <!--              <div class="notify-icon bg-purple"><i class="mdi mdi-account-plus"></i></div>-->
      <!--              <p class="notify-details">New user registered.<small class="text-muted">7 days ago</small></p>-->
      <!--            </a>-->
      <!--            &lt;!&ndash; item&ndash;&gt;-->
      <!--            <a href="javascript:void(0);" class="dropdown-item notify-item">-->
      <!--              <div class="notify-icon bg-primary"><i class="mdi mdi-heart"></i></div>-->
      <!--              <p class="notify-details">Carlos Crouch liked <b>Admin</b><small class="text-muted">13 days ago</small></p>-->
      <!--            </a>-->
      <!--          </div>-->
      <!--          &lt;!&ndash; All&ndash;&gt;-->
      <!--          <a href="javascript:void(0);" class="dropdown-item text-center text-primary notify-item notify-all">-->
      <!--            View all-->
      <!--            <i class="fi-arrow-right"></i>-->
      <!--          </a>-->
      <!--        </div>-->
      <!--      </li>-->

      <li class="dropdown notification-list">
        <div class="nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light">
          <span class="ml-1">
            <a href="javascript:void(0);" (click)="openMenu()" style="color: rgba(255, 255, 255, 0.7);">Current Participant: <b>{{selectedParticipantName}} ({{selectedParticipant}})</b></a>
          </span>
        </div>
      </li>

      <li class="dropdown notification-list">
        <div class="nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light">|</div>
      </li>

      <li class="dropdown notification-list">
        <a class="nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light" data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
          <span class="ml-1">{{(currentUser | async).email}} <i class="mdi mdi-chevron-down"></i> </span>
        </a>
        <div class="dropdown-menu dropdown-menu-right profile-dropdown ">
          <!-- item-->
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">Welcome !</h6>
          </div>


          <!-- item-->
          <a href="javascript:void(0);" (click)="navigateUserProfile()" class="dropdown-item notify-item">
            <i class="fe-user"></i>
            <span>Profile</span>
          </a>


          <div class="dropdown-divider"></div>

          <!-- item-->
          <a href="javascript:void(0);" (click)="navigatePasswordReset()" class="dropdown-item notify-item">
            <i class="fe-lock"></i>
            <span>Reset Password</span>
          </a>

          <div class="dropdown-divider"></div>

          <!-- item-->
          <a href="javascript:void(0);" (click)="openMenu()" class="dropdown-item notify-item">
            <i class="fe-refresh-cw"></i>
            <span>Change Participant</span>
          </a>


          <div class="dropdown-divider"></div>

          <!-- item-->
          <a href="javascript:void(0);" (click)="logout()" class="dropdown-item notify-item">
            <i class="fe-log-out"></i>
            <span>Logout</span>
          </a>

        </div>
      </li>

      <!-- <li class="dropdown notification-list">
        <a class="nav-link right-bar-toggle waves-effect" (click)="openMenu()">
          <i class="fe-settings noti-icon"></i>
        </a>
      </li> -->

    </ul>

    <!-- LOGO -->
    <div class="logo-box">
      <a href="index.html" class="logo text-center">
        <span class="logo-lg">
          <img src="assets/images/logo-light.png" alt="" height="60">
          <!-- <span class="logo-lg-text-light">UBold</span> -->
        </span>
        <span class="logo-sm">
          <!-- <span class="logo-sm-text-dark">U</span> -->
          <img src="assets/images/logo-sm.png" alt="" height="24">
        </span>
      </a>
    </div>

  </div> <!-- end container-fluid-->
</div>
<!-- end Topbar -->
